import MDSpinner from 'react-md-spinner';
import React from 'react';
import { LoadingHolder } from './SmallLoading.styles';

const SmallLoading = (props) => {
  const { showUnderline } = props;

  return (
    <LoadingHolder showUnderline={showUnderline}>
      <MDSpinner color1={'#bcbcbc'} color2={'#bcbcbc'} color3={'#bcbcbc'} color4={'#bcbcbc'} size={20} />
    </LoadingHolder>
  );
};

export default React.memo(SmallLoading);
